module.exports = __webpack_public_path__ + "img/wave_home.9ff4c2fb.svg";